<template>
	<v-container class="white" grid-list-xl fluid ma-0 pa-0>
		<v-layout row wrap>
			<v-flex sm3>
				<v-avatar slot="icon" color="blue accent-3" size="30">
					<v-icon icon="mdi-file" color="white">
						mdi-file-multiple</v-icon
					> </v-avatar
				>Manage Files
			</v-flex>
			<v-spacer> </v-spacer><v-spacer> </v-spacer>
			<v-flex sm1>
				<v-avatar size="25" class="light-blue darken-2 elevation-5 mx-1">
					<v-icon fab class="mx-1" xs-small dark @click="openHelp()">
						mdi-help</v-icon
					>
				</v-avatar>
			</v-flex>
		</v-layout>
		<br />

		<v-row no-gutters>
			<v-col cols="6" sm="3" md="2">
				<v-card class="pa-1 elevation-0">
					<v-autocomplete
						background-color="green lighten-5"
						outlined
						dense
						placeholder=" "
						label="Choose Bucket"
						class="caption pt-0 mx-2"
						:items="listS3Buckets()"
						v-model="selectedbucket"
					></v-autocomplete>
					<v-autocomplete
						background-color="green lighten-5"
						outlined
						dense
						placeholder=" "
						label="Choose Folder"
						class="caption pt-0 mx-2"
						:items="getFolderList()"
						v-model="selected"
					></v-autocomplete>
				</v-card>
			</v-col>

			<v-col cols="6" sm="3" md="2">
				<v-card class="pa-1 elevation-0">
					<v-btn
						outlined
						color="green lighten-2"
						class="py-4"
						small
						dense
						dark
						@click="addfolder()"
					>
						<v-icon small class="caption" fab dark @click.stop="addfolder()"
							>mdi-plus-thick</v-icon
						>New Folder</v-btn
					>
					<v-btn
						outlined
						color="yellow darken-3"
						class="my-8 py-4 pa-2 caption"
						small
						dense
						dark
						@click="refresh()"
						><v-icon class="mx-3" fab dark @click.stop="refresh()"
							>mdi-refresh</v-icon
						>Refresh</v-btn
					>
				</v-card>
			</v-col>

			<v-col cols="12" sm="6" md="5">
				<v-card class="pa-1 elevation-0">
					<v-file-input
						multiple
						placeholder=" "
						id="clttsfiles"
						ref="inputUpload"
						type="file"
						outlined
						label="Select One or Multiple Files"
						@change="selectFile"
						show-size
						counter
						dense
						small-chips
					>
						<template v-slot:selection="{ text }">
							<v-chip small label color="info">{{ text }}</v-chip>
						</template>
					</v-file-input>
					<v-btn
						outlined
						color="indigo lighten-3"
						class="caption py-4 pa-2 mx-9"
						small
						dark
						@click="upload()"
						>Upload File<v-icon class="mx-2" dark @click.stop="upload()"
							>mdi-cloud-upload</v-icon
						></v-btn
					>
					<v-div class="caption">{{ message }}</v-div>
				</v-card>
			</v-col>

			<v-col cols="12" sm="6" md="3">
				<v-card class="pa-1 elevation-0">
					<v-text-field
						outlined
						dense
						placeholder="Search"
						prepend-inner-icon="mdi-magnify"
						class="mx-1 caption"
						v-model="search"
					></v-text-field>
				</v-card>
			</v-col>
		</v-row>

		<v-dialog v-model="popup" max-width="500">
			<v-card>
				<v-toolbar dark color="indigo lighten-2" height="30">
					<v-toolbar-title class="caption">Rename File</v-toolbar-title>
					<v-spacer></v-spacer>
					<v-icon xs-small class="red" dark @click.stop="close()"
						>mdi-close
					</v-icon> </v-toolbar
				><br />
				<v-form
					ref="form"
					v-model="valid"
					:close-on-content-click="false"
					full-width
					min-width="950px"
				>
					<v-text-field
						ref="Json.Key"
						outlined
						dense
						class="caption mr-1 px-3"
						v-model="Json.Key"
						label="File Name"
						placeholder=" "
						height="20"
						required
						disabled
					></v-text-field>
					<v-text-field
						ref="Json.NewKey"
						outlined
						dense
						class="caption mr-2 px-3"
						v-model="Json.NewKey"
						label="New File Name (folder name/file name)"
						placeholder=" "
						height="20"
					></v-text-field>
					<v-btn
						dark
						small
						outlined
						dense
						class="center red lighten-2 mr-2 px-1"
						@click="close()"
						>Cancel</v-btn
					>
					<v-btn
						dark
						small
						outlined
						class="indigo lighten-2 mr-2 px-2"
						@click="submit()"
						>Update
					</v-btn> </v-form
				><br />
			</v-card>
		</v-dialog>

		<v-dialog v-model="pop" persistent max-width="500">
			<v-card>
				<v-form
					ref="form"
					v-model="valid"
					lazy-validation
					:close-on-content-click="false"
					offset-y
					full-width
					min-width="950px"
				>
					<v-toolbar dark color="indigo lighten-2" height="25">
						<v-toolbar-title class="caption">Create Folder</v-toolbar-title>
						<v-spacer></v-spacer>
						<v-icon xs-small class="red" dark @click.stop="close()"
							>mdi-close
						</v-icon>
					</v-toolbar>
					<br />
					<v-row class="mx-1 pa-2">
						<v-col cols="12" sm="12" md="12">
							<v-text-field
								ref="Json.NewFolder"
								outlined
								dense
								class="caption mr-2"
								v-model="Json.NewFolder"
								label="New Folder"
								placeholder=" "
								height="20"
							></v-text-field>
							<v-btn
								dark
								small
								outlined
								class="red lighten-2 mr-2"
								@click="close()"
								>Cancel</v-btn
							>
							<v-btn
								dark
								small
								outlined
								class="indigo lighten-2 mr-2"
								@click="createFolder()"
								>Create</v-btn
							>
						</v-col>
					</v-row>
				</v-form>
			</v-card>
		</v-dialog>

		<v-dialog v-model="howtopop" persistent max-width="900">
			<v-card>
				<v-toolbar dark color="indigo lighten-2" height="25">
					<v-toolbar-title class="caption">How To ?</v-toolbar-title>
					<v-spacer></v-spacer>
					<v-icon xs-small class="red" dark @click.stop="close()"
						>mdi-close
					</v-icon>
				</v-toolbar>
				<iframe
					width="900"
					height="636"
					src="https://www.youtube.com/embed/MNYgvtQzrHg"
					frameborder="0"
					allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
					allowfullscreen
				></iframe>
			</v-card>
		</v-dialog>

		<v-data-table
			dense
			:headers="headers"
			:items-per-page="100"
			v-bind:items="s3Files"
			v-bind:search="search"
			:loading="loading"
			:sort-by="['LastModified']"
			:sort-desc="[true]"
			multi-sort
			class="elevation-0"
		>
			<template v-slot:item.Key="{ item }">
				<v-div
					v-if="bytesToMegaBytes(item.Size) != 'n/a'"
					class="caption"
					label
					small
					>{{ item.Key }}</v-div
				>
			</template>
			<template v-slot:item.Download="{ item }">
				<v-chip
					small
					v-if="bytesToMegaBytes(item.Size) != '15 Bytes'"
					outlined
					class="caption ma-1"
					color="primary"
					label
					dark
				>
					<v-icon small dark>mdi-file-pdf</v-icon>
					<v-div
						dark
						v-html="getDetails(item.Key)"
						color="primary"
						class="caption text elevation-0 px-1 body-2"
					></v-div>
				</v-chip>
			</template>
			<template v-slot:item.Link="{ item }">
				<v-div
					v-if="bytesToMegaBytes(item.Size) != '15 Bytes'"
					dark
					v-html="getLink(item.Key)"
					color="primary"
					class="caption text elevation-0 px-1 body-2"
				></v-div>
			</template>
			<template v-slot:item.Rename="{ item }">
				<v-avatar
					v-if="bytesToMegaBytes(item.Size) != '15 Bytes'"
					size="25"
					class="light-blue elevation-10"
					@click="renameFile(item.Key)"
					><v-icon fab small dark>mdi-pencil</v-icon></v-avatar
				>
			</template>
			<template
				v-slot:item.Delete="{ item }"
				v-if="this.loggedInUser != 'Teacher'"
			>
				<v-avatar
					v-if="bytesToMegaBytes(item.Size) != '15 Bytes'"
					size="25"
					class="red lighten-1 mx-2 elevation-10"
					><v-icon small dark @click="deletefile(item.Key)"
						>mdi-delete</v-icon
					></v-avatar
				>
			</template>
			<template v-slot:item.LastModified="{ item }">
				<v-div
					v-if="bytesToMegaBytes(item.Size) != '15 Bytes'"
					class="caption"
					label
					small
					>{{ changeDate(item.LastModified) }}</v-div
				>
			</template>
			<template v-slot:item.Size="{ item }">
				<v-div
					v-if="bytesToMegaBytes(item.Size) != '15 Bytes'"
					class="text elevation-0 px-2 body-2"
					>{{ bytesToMegaBytes(item.Size) }}</v-div
				>
			</template>
			<template v-slot:item.UploadedBy="{ item }">
				<v-div
					v-if="bytesToMegaBytes(item.Size) != '15 Bytes'"
					class="text elevation-0 px-2 caption"
				>
					<get-uploaded
						:bucket="selectedbucket"
						:keyname="item.Key"
					></get-uploaded>
				</v-div>
			</template>
		</v-data-table>
	</v-container>
</template>

<script>
	import ReportServices from '@/services/ReportServices'
	import GetUploaded from '@/components/GetUploaded'

	export default {
		data() {
			return {
				headers: [
					{ text: 'File Name', align: 'left', value: 'Key', width: '20' },
					{ text: 'AWS Link', align: 'left', value: 'Link', width: '40' },
					{ text: 'Download', align: 'left', value: 'Download', width: '5' },
					// { text: 'Rename', align: 'left', value: 'Rename', width: '5' },
					{ text: 'Uploaded By', align: 'left', value: 'UploadedBy', width: '5'},
					{ text: 'Uploaded At', align: 'left', value: 'LastModified', width: '20'},
					{ text: 'File Size', align: 'left', value: 'Size', width: '5' },
					{ text: 'Del', align: 'left', value: 'Delete', width: '5' },
				],
				Json: {
					Key: '',
					NewKey: '',
					LastModified: '',
					Size: '',
					NewFolder: '',
				},
				search: '',
				loading: false,
				s3Files: [],
				select: null,
				popup: false,
				pop: false,
				howtopop: false,
				currentFile: undefined,
				message: 'No Messages',
				s3Folders: [],
				selected: 'Please select',
				S3Buckets: [],
				selectedbucket: 'cltts-docs',
				url: 'https://www.youtube.com/watch?v=MNYgvtQzrHg',
			}
		},
		components: {
			GetUploaded,
		},
		watch: {
			selected() {
				this.getS3Files(this.selected)
			},
			selectedbucket() {
				this.selectedbucket
				this.refresh()
			},
		},
		computed: {
			loggedInUser() {
				var user = this.$store.getters.email
				var role = this.$store.getters.role
				if (user && role === 'SuperAdmin') return 'SuperAdmin'
				else if (user && role === 'Admin') return 'Admin'
				else return 'Member'
			},
			loggedInPerson() {
				return this.$store.getters.email
			},
		},
		methods: {
			openHelp() {
				this.howtopop = true
			},
			selectFile(file) {
				this.currentFile = file
			},
			async addfolder() {
				this.pop = true
				this.cleardata()
			},
			listS3Buckets() {
				var Folder = []
				this.S3Buckets.forEach(sInfo => {
					if (this.loggedInUser === 'SuperAdmin' || this.loggedInUser === 'Admin') {
						Folder.push(sInfo.Name)
					}
				})
				return Folder.sort()
			},
			async getS3Files(getS3Folder) {
				this.s3Files = []
				this.getS3Folder = getS3Folder
				this.noDataText =
					'Fetching data from server and computing results ......'
				this.s3Files = (
					await ReportServices.getUploadedFiles(
						this.selectedbucket,
						this.getS3Folder
					)
				).data
				this.loading = false
				this.noDataText = 'No data available'
			},
			getFolderList() {
				var ListFolder = []
				this.s3Folders.forEach(sInfo => {
					ListFolder.push(sInfo.Prefix.replace('/', ''))
				})
				return ListFolder.sort()
			},
			async createFolder() {
				ReportServices.createFolder(this.selectedbucket, this.Json.NewFolder)
				this.pop = false
				setTimeout(() => {
					this.refresh()
					this.message = 'Folder Created Successfully'
				}, 500)
			},
			upload() {
				if (!this.currentFile) {
					this.message = 'Please select a file!'
					return
				}
				var options = {
					header: {
						'Content-Type': 'multipart/form-data',
					},
				}
				var files = document.getElementById('clttsfiles').files
				var formData = new FormData()
				for (let i = 0; i < files.length; i++) {
					formData.append('cltts', files[i], files[i].name, options)
				}
				ReportServices.uploadfile(
					formData,
					this.selectedbucket,
					this.getS3Folder,
					this.loggedInPerson
				)
					.then(response => {
						this.message = response.data.message
						setTimeout(() => {
							this.refresh()
						}, 1000)
					})
					.then(files => {
						this.fileInfos = files.data
					})
					.catch(() => {
						this.message = 'Files Uploaded Successfully'
						this.currentFile = undefined
					})
			},
			deletefile(key) {
				ReportServices.deleteS3File(this.selectedbucket, key)
				setTimeout(() => {
					this.refresh()
					this.message = 'File Deleted Successfully'
				}, 500)
			},
			close() {
				this.popup = false
				this.pop = false
				this.howtopop = false
			},
			bytesToMegaBytes(bytes) {
				const sizes = ['Bytes', 'KB', 'MB', 'GB', 'TB']
				if (bytes === 0) return 'n/a'
				const i = parseInt(
					Math.floor(Math.log(Math.abs(bytes)) / Math.log(1024)),
					10
				)
				if (i === 0) return `${bytes} ${sizes[i]}`
				return `${(bytes / 1024 ** i).toFixed(1)} ${sizes[i]}`
			},
			getDetails(detail) {
				var ahtml = ''
				var html =
					'https://' + this.selectedbucket + '.s3.amazonaws.com/' + detail
				if (html.startsWith('http')) {
					ahtml = html.replace(
						html,
						'<a href="' + html + '" target="_blank">' + 'File' + '</a>'
					)
					return ahtml
				}
				return html
			},
			getLink(detail) {
				return 'https://' + this.selectedbucket + '.s3.amazonaws.com/' + detail
			},
			renameFile(id) {
				this.cleardata()
				if (id) {
					this.popup = true
					this.Json.Key = id
					this.Json.NewKey = id
				}
			},
			async cleardata() {
				this.Json.Key = ''
				this.Json.NewKey = ''
				this.Json.NewFolder = ''
			},
			async submit() {
				ReportServices.renameS3File(
					this.selectedbucket,
					this.Json.Key,
					this.Json.NewKey
				)
				this.popup = false
				setTimeout(() => {
					this.refresh()
					this.message = 'File Renamed Successfully'
				}, 500)
			},
			changeDate(date) {
				var options = {
					timeZone: 'America/New_York',
					hour12: 'true',
					year: '2-digit',
					month: 'short',
					day: 'numeric',
					hour: '2-digit',
					minute: '2-digit',
					second: '2-digit',
				}
				return new Date(date).toLocaleTimeString('en-us', options)
			},
			logoutFromFirebase() {
				this.$store
					.dispatch('signOutAction')
					.then(() => this.$router.replace('/Signin'))
			},
			async refresh() {
				this.loading = true
				this.S3Buckets = (await ReportServices.getS3Buckets()).data
				this.s3Folders = (
					await ReportServices.getFoldersFromS3(this.selectedbucket)
				).data
				await this.getS3Files(this.selected)
				this.loading = false
				this.noDataText = 'No data available'
				this.$refs.inputUpload.reset()
			},
		},
		async mounted() {
			this.refresh()
		},
	}
</script>
